<template>
  <div class="salary-form">
    <div class="salary-form-container">
      <div class="search">
        <div class="canteen-name">
          <div class="canteen-title">制表时间</div>
          <el-date-picker
            v-model="month"
            type="month"
            placeholder="选择月"
            value-format="yyyy-MM"
            @change="initSalary"
          >
          </el-date-picker>
        </div>
        <div>
          <el-button
            type="text"
            class="btn-border-text-blue"
            @click="createdExpense"
            >生成费用单</el-button
          >
          <el-button
                v-if="
                  OPERATION_LIST.findIndex(
                    (item) => item === OPERATIONS_BTNS.roleAddSalaryTable
                  ) !== -1
                "
            type="text"
            class="btn-blue add"
            icon="el-icon-plus"
            @click="toAddSalaryForm"
            >新增</el-button>
        </div>
      </div>
      <div class="warning" v-if="tableData.length == 0">
        <i class="el-icon-warning"></i>
        本月中未生成工资条，请先新增
      </div>
      <div class="salary-container">
        <div v-if="tableData.length > 0" class="table-container">
          <el-checkbox-group v-model="selectCreateExpenseList" @change="changeSelcetCreateExpense">
            <div
              v-for="(item,index) in tableData"
              :key="index"
              class="table-main"
            >
              <div class="table-title">
                <el-checkbox :label="item.id" :disabled="item.isDisabled">
                  <span class="salary-name">{{item.title}}</span>
                  <span v-show="item.reimburseDate" class="reimbursement-date">（报销日期：{{item.reimburseDate}}）</span>
                  <el-tooltip
                    v-if="item.isCreateExpense"
                    effect="dark"
                    placement="top">
                    <div slot="content">
                      已生成费用单
                    </div>
                    <img class="create-expense" src="../../../../assets/food/create-expense.png">
                  </el-tooltip>
                </el-checkbox>
                <div
                  class="operation"
                  v-if="
                    OPERATION_LIST.findIndex(
                      (item) => item === OPERATIONS_BTNS.roleSalaryMethodBotton
                    ) !== -1
                  "
                >
                  <el-button
                    v-if="item.validStatus == 'Valid' && item.initiateApprovalFlag == 0"
                    type="text"
                    :disabled="item.initiateApprovalFlag == 1"
                    :class="item.initiateApprovalFlag == 1 ?'btn-lightGrey':'btn-text'"
                    @click="toModSalaryFrom(item.id, 1)"
                    >编辑</el-button>
                  <el-dropdown trigger="click" @command="handleCommand" >
                    <span class="el-dropdown-link">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="item.validStatus == 'Valid'" :command="beforeHandleCommand(item, 'print')">打印</el-dropdown-item>
                      <el-dropdown-item v-if="item.validStatus == 'Valid'" :command="beforeHandleCommand(item, 'copy')">复制</el-dropdown-item>
                      <el-dropdown-item v-if="item.validStatus != 'Invalid' && !item.isCreateExpense" :command="beforeHandleCommand(item, 'nullify')">作废</el-dropdown-item>
                      <el-dropdown-item v-if="item.validStatus === 'Invalid'" :command="beforeHandleCommand(item, 'del')">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="table-content">
                <div class="table-title-content">
                  <div class="table-title-nums">
                    <p class="nums-content">{{item.sendNum}}/{{item.totalNum}}</p>
                    <p>已发送</p>
                  </div>
                  <div class="table-title-nums">
                    <p class="nums-content">{{item.checkNum}}/{{item.totalNum}}</p>
                    <p>已查看</p>
                  </div>
                  <div class="table-title-nums">
                    <p class="nums-content">{{item.confirmNum}}/{{item.totalNum}}</p>
                    <p>已确认</p>
                  </div>
                </div>
                <div
                    v-if="OPERATION_LIST.findIndex(
                    (item) => item === OPERATIONS_BTNS.roleSalaryMethodBotton
                  ) !== -1"
                >
                  <el-button
                    v-if="item.initiateApprovalFlag == 1 && item.validStatus === 'Valid'"
                    type="text"
                    class="btn-border-text-blue"
                    @click="openprocedure(item.id)"
                    >查看流程</el-button
                  >
                  <el-button
                    v-if="item.status == 'Agreed' && item.validStatus === 'Valid'"
                    type="text"
                    class="btn-border-text-blue"
                    @click="toSendSalary(item.id)"
                    >前往发送</el-button
                  >
                  <el-button
                    v-if="item.initiateApprovalFlag == 0 && item.validStatus === 'Valid'"
                    type="text"
                    class="btn-blue"
                    @click="launchApproval(item.id)"
                    >发起审批</el-button
                  >
                  <el-button
                    v-if="item.initiateApprovalFlag == 1 && item.validStatus === 'Valid' &&
                    (item.status == 'Pending' || item.status == 'Approval')"
                    type="text"
                    class="btn-border-text-red"
                    @click="withdrawalApproval(item.id)"
                    >撤回审批</el-button
                  >
                </div>
              </div>
            </div>
          </el-checkbox-group>
        </div>
        <div class="nothing" v-else>
          <div>
            <div>
              <img src="../../../../assets/nothing.png">
            </div>
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 流程记录 -->
    <el-dialog
      class="approvalRecordDialog"
      title="查看流程"
      top="15vh"
      :visible.sync="approvalRecordDialog"
      width="420px"
    >
      <el-steps :active="steps" direction="vertical">
        <el-step v-for="(item,index) in stepList" :key="index" :class="{isRefuse: item.isRefuse}">
          <div slot="icon" class="stepsImg">
            <div v-if="item.isApprovel">
              {{index+1}}
            </div>
            <img v-else :src="steps === item.step ? item.highLightIcon : item.icon">
          </div>
          <div slot="title">
            <div class="title" :class="item.currentApprove ?(item.approvalRes == 2 ?'red-active':'blue-active'):''">
              <div>
                <span>{{ item.approverName }}</span>
                <span v-if="item.time">({{ item.time }})</span>
              </div>
              <!-- <span class="passStatus">{{ item.passStatus }}</span> -->
            </div>
            <div v-if="item.remark" class="remark">备注：{{ item.remark }}</div>
          </div>
        </el-step>
      </el-steps>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-blue" @click="confirm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 工资条打印 -->
    <el-dialog class="printer-dialog" top="10vh" title="打印" :visible.sync="printerDialog" width="1040px" :close-on-click-modal="false">
      <div class="print-title">
        <el-input class="gray white" placeholder="输入打印标题" v-model="printTitle"></el-input>
      </div>
      <div class="printer" id="printer">
        <div>
          <div class="print-title print-title-show">
            {{printTitle}}
          </div>
          <div class="table" :style="`zoom:${zoom}%`">
            <el-table
              class="table-printer"
              :data="tablePrintData"
              style="width:100%;"
            >
              <el-table-column label="序号" width="80" prop="sort"></el-table-column>
              <el-table-column label="姓名" prop="name" min-width="90"></el-table-column>
              <el-table-column label="部门" prop="deptName" min-width="104"></el-table-column>
              <el-table-column 
                v-for="(item, index) in tableTitleList" 
                :key="index"
                :label="item.name"
                min-width="90"
              >
                <template slot-scope="scope">
                  {{scope.row[item.nameKey]}}
                </template>
              </el-table-column>
              <el-table-column label="实发金额" prop="actuallyAmount" min-width="90"></el-table-column>
            </el-table>
            <div class="print-remark">
              <span class="print-remark-title">备注</span>
              <span class="print-remark-content">{{ printRemark }}</span>
            </div>
          </div>
          <div class="sign-container">
            <div class="sign-content">
              <p>
                长：
              </p>
              <div class="show-sign">
                <img
                  class="sign-img"
                  v-for="(item, index) in chiefList"
                  :key="index"
                  :src="item">
              </div>
            </div>
            <div class="sign-content approval-sign-content" >
              <p class="approval-sign-title">
                审核：
              </p>
              <div class="approval-show-sign" :class="(departmentHead.length === 0 || financialAuditList.length === 0)?'active-show-sign':''">
                <div v-if="departmentHead.length > 0">
                  <img
                    class="sign-img"
                    v-for="(item, index) in departmentHead"
                    :key="index"
                    :src="item">
                </div>
                <div v-if="financialAuditList.length > 0">
                  <img
                    v-for="(item, index) in financialAuditList"
                    :key="index"
                    :src="item">
                </div>
              </div>
            </div>
            <div class="sign-content">
              <p>
                制表：
              </p>
              <div class="show-sign">
                <p class="watch-marker">{{watchmaker}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-input-number class="gray white w120" v-model="zoom" :min="0" :max="100" controls-position="right" placeholder="请输入"></el-input-number>
        <el-button class="btn-white" @click="closePrinterDialog">取消</el-button>
        <el-button class="btn-blue" v-print="'#printer'">确定</el-button>
      </div>
    </el-dialog>

    
    <el-dialog
      class="create-expense-dialog"
      :visible.sync="dialogCreateExpenseVisible"
      width="540px"
      :before-close="handleCreateExpenseClose"
    >
      <div slot="title">
        <span>生成费用单</span>
        <el-tooltip
          effect="dark"
          placement="right">
          <div slot="content">
            费用单生成后，请在手机端及时发起报销
          </div>
          <img class="tooltip" src="../../../../assets/tooltip.png" alt>
        </el-tooltip>
      </div>
      <el-form
        ref="createExpenseForm"
        :model="createExpenseForm"
        :rules="createExpenseFormRules"
        class="demo-ruleForm"
      >
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="createExpenseForm.date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            class="white"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开支内容" prop="content">
          <el-input class="gray white" placeholder="请输入" v-model="createExpenseForm.content"></el-input>
        </el-form-item>
        <el-form-item label="金额（元）" prop="amount">
          <el-input class="gray white" placeholder="请输入" v-model="createExpenseForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="选择接收人" prop="selectRecipient">
          <el-select
            v-model="createExpenseForm.selectRecipient"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in selectRecipientList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCreateExpenseClose">取 消</el-button>
        <el-button type="primary" @click="confirmCreateExpense('createExpenseForm')">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import Salary from "@/models/salary.js";
import { formatTimeToDate, handleAmount } from "@/common/js/utils.js"
import { operationMixins } from '@/common/mixins/operation/operation.js'
export default {
  mixins: [operationMixins],

  data() {
    return {
      month: '',
      tableData: [],
      
      approvalRecordDialog: false,
      steps: 1,
      stepList: [],
      finishIcon: require('../../../../assets/fixed-assets/approval-finish.png'),

      printRemark: '',
      tablePrintData: [],
      tableTitleList: [],
      // 长官签名
      chiefList: [],
      // 财务审核人签名
      financialAuditList: [],
      // 部门负责人人签名
      departmentHead: [],
      // 制表人
      watchmaker: '',
      printerDialog: false,
      printTitle: '',
      // 缩放比例
      zoom: 100,
      selectCreateExpenseList: [],
      dialogCreateExpenseVisible: false,
      selectRecipientList: [],
      createExpenseForm: {
        date: '',
        content: null,
        amount: null,
        selectRecipient: null
      },
      createExpenseFormRules: {
        date: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        content: [{ required: true, message: "请输入开支内容", trigger: "blur" }],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
        selectRecipient: [
          { required: true, message: "请选择接收人", trigger: "change" },
        ]
      },
    }
  },

  created() {
    config()
    this.initSalary()
    this.initSelectRecipientList()
  },

  methods: {
    initSalary() {
      let month = this.month
      Salary.getSalaryList(month).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.checkNum = i.checkNum
            obj.confirmNum = i.confirmNum
            obj.id = i.id
            obj.initiateApprovalFlag = i.initiateApprovalFlag
            obj.sendNum = i.sendNum
            obj.status = i.status
            obj.templateId = i.templateId
            obj.title = i.title
            obj.totalNum = i.totalNum
            obj.validStatus = i.validStatus
            obj.totalIncrementAmount = handleAmount(i.totalIncrementAmount,2)
            obj.isCreateExpense = i.hasCreateBill
            obj.reimburseDate = i.reimburseDate !== 0 ? formatTimeToDate(i.reimburseDate) :''
            if (i.validStatus === 'Invalid' || i.hasCreateBill) {
              obj.isDisabled = true
            } else {
              obj.isDisabled = false
            }
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 打印详情 */
    initPrintDetails(id) {
      Salary.getPrintData(id).then(res => {
        if (res.success) {
          let { remark, itemList, paySlipItemList, totalObj, watchmaker, roleTypeSignList } = res.result
          let chiefArr = [4, 2, 6]
          this.printRemark = remark
          this.watchmaker = watchmaker
          let chiefList = []
          let financialAuditList = []
          let departmentHead = []
          let tableTitleList = []
          itemList.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            obj.type = i.type
            obj.nameKey = `${i.name}${i.id}${i.type}`
            tableTitleList.push(obj)
          })
          this.tableTitleList = tableTitleList
          let arr = []
          paySlipItemList.map(i => {
            let obj = {}
            obj.sort = i.serial
            obj.name = i.username
            obj.deptName = i.deptName
            obj.actuallyAmount = i.actuallyAmount
            i.itemValueList.map(v => {
              tableTitleList.map(j => {
                if (v.id == j.id && v.type == j.type) {
                  obj[j.nameKey] = v.value
                }
              })
            })
            arr.push(obj)
          })
          let totalAmountObj = {}
          totalAmountObj.sort = '合计'
          totalAmountObj.name = ''
          totalAmountObj.deptName = ''
          totalAmountObj.actuallyAmount = totalObj.actuallyAmount
          totalObj.itemValueList.map(v => {
            tableTitleList.map(j => {
              if (v.id == j.id && v.type == j.type) {
                totalAmountObj[j.nameKey] = v.value
              }
            })
          })
          arr.push(totalAmountObj)
          this.tablePrintData = arr
          roleTypeSignList.map(i => {
            if (i.sign) {
              let img = `${i.sign}?x-oss-process=image/resize,h_30,m_lfit`
              if (i.roleType == 1) {
                departmentHead.push(img)
              }
              if (i.roleType == 3) {
                financialAuditList.push(img)
              }
              chiefArr.map(v => {
                if (v == i.roleType) {
                  if (i.roleType == 4) {
                    chiefList.unshift(img)
                  } else {
                    chiefList.push(img)
                  }
                }
              })
            }
          })
          this.chiefList = chiefList
          this.financialAuditList = financialAuditList
          this.departmentHead = departmentHead
          this.zoom = 100
          this.printerDialog = true
        } else {
          this.$message.error(res.message);
        }
      })
    },

    initSelectRecipientList() {
      Salary.getSelectRecipientList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.userId
            obj.name = i.userName
            arr.push(obj)
          })
          this.selectRecipientList = arr
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 作废 */
    nullify(id) {
      let data = {
        id
      }
      Salary.postSalaryFormNullify(data).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: '作废成功',
          });
          this.initSalary()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 删除 */
    delSalaryForm(id) {
      this.$confirm("工薪表删除后不可恢复，是否继续？", "确认删除工薪表", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        }
        Salary.postDelSalaryForm(data).then(res => {
          if (res.success) {
            this.$message({
              type: "success",
              message: '删除成功',
            });
            this.initSalary()
          } else {
            this.$message.error(res.message);
          }
        })
      });
    },
    
    /* 发起审批 */
    launchApproval(id) {
      let data = {
        id
      };
      Salary.postInitiateApproval(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "发起审批成功",
          });
          this.initSalary()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 撤回审批 */
    withdrawalApproval(id) {
      let data = {
        id
      }
      Salary.postSalaryFormWithdrawalApproval(data).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: '撤回成功',
          });
          this.initSalary()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 流程记录 */
    initProcedureRecord(id) {
      Salary.getProcedureRecord(id).then(res => {
        if (res.success) {
          let arr = []
          res.result.map((i,index) => {
            let obj = {}
            if (i.id) {
              obj.isApprovel = true
              if (i.approvalRes == 2) {
                obj.isRefuse = true
              } else if (i.approvalRes == 1) {
                obj.icon = this.finishIcon
                obj.isRefuse = false
                obj.isApprovel = false
              } else {
                obj.isRefuse = false
              }
              this.steps = index+1
              obj.id = i.id
              obj.approvalRes = i.approvalRes
              obj.currentApprove = i.currentApprovalFlag
              obj.remark = i.remark
              obj.approverName = i.approverName ? `审批人（${i.approverName}）`:`审批人`
            } else {
              obj.isApprovel = false
              obj.isRefuse = false
              obj.icon = this.finishIcon
              obj.approverName = i.approverName ? `制表人（${i.approverName}）`:`制表人`
            }
            obj.time = i.approvalTime > 0 ?formatTimeToDate(i.approvalTime):''
            arr.push(obj)
          })
          this.stepList = arr
        } else {
          this.$message.error(res.message);
        }
      })
    },

    
    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value,command){
      return {
        'value': value,
        'command':command
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "print":
          this.initPrintDetails(command.value.id)
          break;
        case "copy":
          this.toModSalaryFrom(command.value.id, 2, command.value.templateId)
          break;
        case "nullify":
          this.nullify(command.value.id)
          break;
        case "del":
          this.delSalaryForm(command.value.id)
          break;
      }
    },
    
    confirm() {
      this.approvalRecordDialog = false
    },

    /* 打开流程 */
    openprocedure(id) {
      this.initProcedureRecord(id)
      this.approvalRecordDialog = true
    },

    /* 跳转发送工资条页面 */
    toSendSalary(id) {
      this.$router.push({
        path: '/fire/salaryModuleIndex/salaryFormIndex/salarySend',
        query: {
          salaryFormId: id,
        }
      })
    },

    /* 跳转新增工资表 */
    toAddSalaryForm() {
      this.$router.push({
        path: '/fire/salaryModuleIndex/salaryFormIndex/addSalaryForm',
        query: {
          isMod: 1
        }
      })
    },

    /* 跳转编辑工资表 */
    toModSalaryFrom(id, type, tmpId) {
      let templateId = tmpId ? tmpId:''
      this.$router.push({
        path: '/fire/salaryModuleIndex/salaryFormIndex/addSalaryForm',
        query: {
          isMod: 2,
          payrollId: id,
          type,
          templateId
        }
      })
    },
    
    closePrinterDialog() {
      this.printerDialog = false
    },

    createdExpense() {
      if (this.selectCreateExpenseList.length === 0) return this.$message.error('请先选择未生成费用单且未作废的工资单')
      this.dialogCreateExpenseVisible = true
    },

    changeSelcetCreateExpense(v) {
      let num = 0
      v.map(i => {
        let obj = this.tableData.find(item => { return item.id == i })
        num += obj.totalIncrementAmount
      })
      this.createExpenseForm.amount = num
    },

    handleCreateExpenseClose() {
      this.createExpenseForm = {
        date: '',
        content: null,
        amount: null,
        selectRecipient: null
      }
      this.dialogCreateExpenseVisible = false
    },

    confirmCreateExpense(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let payrollIdList = this.selectCreateExpenseList
          let date = this.createExpenseForm.date
          let amount = handleAmount(this.createExpenseForm.amount,1)
          let expenditureContent = this.createExpenseForm.content
          let userId = this.createExpenseForm.selectRecipient
          let data = {
            payrollIdList,
            date,
            amount,
            expenditureContent,
            userId,
          }
          Salary.postCreateExpense(data).then(res => {
            if (res.success) {
              this.initSalary()
              this.handleCreateExpenseClose()
              this.selectCreateExpenseList = []
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style lang='scss'>
.salary-form {
  flex: 1;
  padding: 16px 20px;
  box-sizing: border-box;
  background: $bg-white;
  .salary-form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .search {
    margin-bottom: 16px;
    @include flex-between;
    .add {
      padding: 0;
    }
    .canteen-name {
      @include flex-center;
      font-size: $fs-small-l;
      border: 1px solid $bg-ShallowLightSnow;
      .canteen-title {
        height: 32px;
        line-height: 32px;
        padding-left: 19px;
        font-weight: 400;
        color: $color-LightGrey;
      }
      .el-input__inner {
        border: none;
      }
    }
  }
  .warning {
    height: 32px;
    line-height: 32px;
    text-align: left;
    background: $bg-OriginYellow;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color:  $color-OriginYellow;
    padding-left: 12px;
    i {
      margin-right: 8px;
    }
  }
  .salary-container {
    flex: 1;
    position: relative;
    .nothing {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      img {
        width: 157px;
        height: 157px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
    .table-container {
      .el-checkbox-group {
        @include flex-between;
        flex-wrap: wrap;
        .table-main {
          width: 48%;
          margin-right: 32px;
          margin-bottom: 16px;
          border: 1px solid $bg-ShallowLightSnow;
          .table-title {
            height: 44px;
            @include flex-between;
            background: $bg-ChangeDepartmentTree;
            border-bottom: 1px solid $bg-ShallowLightSnow;
            font-size: $fs-medium-s;
            font-weight: 400;
            color: $color-BlackGrey;
            padding: 0px 20px;
            .operation {
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-DeepReddishBlue;
            }
            .create-expense {
              width: 12px;
              height: 16px;
              margin-left: 7px;
              margin-bottom: 4px;
            }
            .salary-name {
              color: $color-BlackGrey;
            }
            .el-checkbox__label {
              cursor: default;
            }
          }
          .table-content {
            padding: 20px;
            @include flex-between;
            .table-title-content {
              flex: 1;
              @include flex-start;
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-LightGrey;
              .table-title-nums {
                width: 33.33%;
                text-align: left;
                .nums-content {
                  font-size: $fs-medium-s;
                  font-weight: 500;
                  margin-bottom: 10px;
                  color: $color-DepartmentPeople;
                }
              }
            }
          }
        }
        .table-main:nth-of-type(even) {
          margin-right: 0px;
        }
      }
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    margin-left: 10px;
  }
  
  .approvalRecordDialog {
    .el-dialog {
      height: 360px;
    }
    .el-dialog__body {
      height: 200px;
      padding: 20px;
    }
    .el-dialog__footer {
      padding-right: 0px;
      @include flex-end;
    }
    .dialog-footer {
      margin-right: 20px;
      padding: 0px;
    }
    .title {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .passStatus {
        margin-left: 50px;
      }
      div,
      span {
        line-height: 16px;
      }
    }
    .blue-active {
      color: $color-DeepReddishBlue;
    }
    .red-active {
      color: $color-PhoneStar;
    }
    .remark {
      width: 340px;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
    }
    .el-step__icon,
    .stepsImg {
      width: 16px;
      height: 16px;
    }
    .el-step__head.is-process {
      color: $color-LightGrey;
      border-color: $color-LightGrey;
    }
    .isRefuse {
      .el-step__head {
        .el-step__icon {
          border-color: $bg-Crimson;
          background: $bg-Crimson;
          color: $color-white;
        }
      }
      .el-step__main {
        .el-step__title {
          .title {
            color: $color-Crimson;
          }
        }
      }
    }
  }
  
  .printer-dialog {
    .el-dialog {
      width: 1088px!important;
      .el-dialog__header {
        border: none;
      }
      .el-dialog__body {
        padding: 0px 20px;
        .el-input-number {
          line-height: 32px;
          margin-right: 20px;
        }
        .el-input-number.is-controls-right .el-input-number__decrease,
        .el-input-number.is-controls-right .el-input-number__increase {
          line-height: 15px;
        }
        .print-title {
          margin-bottom: 10px;
        }
      }
      .sign-container {
        width: auto!important;
        align-items: center;
        position: absolute;
        height: 120px!important;
        z-index: 111;
        .sign-content {
          display: flex;
          align-items: flex-end;
          margin-right: 40px;
          .show-sign,
          .approval-show-sign {
            .sign-img {
              margin-right: 10px;
            }
          }
          .watch-marker {
            font-size: 26px;
            line-height: 30px!important;
            text-align: center;
          }
        }
      }
    }
    .el-table__body-wrapper { 
      height: 400px;
      overflow: auto;
    }
    .footer {
      height: 120px;
      line-height: 120px;
      text-align: right;
    }
    .el-table__footer-wrapper {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
    .print-remark {
      padding: 10px 0px;
      text-align: left;
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
      color: #666666;
      border: 1px solid #000;
      @include flex-start;
      .print-remark-title {
        display: inline-block;
        padding-left: 16px;
        text-align: center;
        margin-right: 250px;
      }
      .print-remark-content {
        flex: 1;
      }
    }
    .print-title-show {
      display: none!important;
    }
    .print-title .el-input__inner {
      text-decoration: underline;
      text-decoration-style: dashed;
      text-underline-offset: 21%;
      text-align: center;
      border: none;
      font-size: 24px;
      color: #333;
    }
  }
  
  .create-expense-dialog {
    .tooltip {
      margin-left: 4px;
    }
    .dialog-footer {
      width: 100%;
      padding-right: 10px;
      @include flex-end;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
    }
    .el-dialog__body {
      padding: 20px 32px 30px 32px;
    }
    .el-dialog__body .el-form {
      padding: 0px;
    }
    
    .el-form-item.is-required:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
      display: none;
    }
    .el-form-item.is-required:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
      content: "*";
      color: $bg-Required;
      margin-left: 4px;
    }
    .el-form-item__label {
      line-height: 30px;
    }
  }
}
</style>
<style midia="print">
#printer .print-title {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
}
#printer .print-title .el-input__inner {
  text-align: center;
  border: none;
  font-size: 24px;
  color: #333;
}
#printer .print-title-show {
  font-size: 24px;
  height: 26px;
  color: #333;
}
#printer .table .el-table {
  border: 1px solid #000;
  border-bottom: none;
}
#printer .el-table th.is-leaf {
  border-bottom: 1px solid #000;
}
#printer .table .el-table td {
  border-bottom: 1px solid #000;
}
#printer .el-table__footer-wrapper td {
  border-top: 1px solid #000;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
  height: auto;
  line-height: 20px;
  font-size: 12px;
}
#printer .table th {
  width: 60px;
}
#printer .sign-container {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#printer .sign-content {
  display: flex;
  align-items: flex-end;
}

#printer .approval-sign-content {
  align-items: flex-start;
  height: 92px;
}
#printer .approval-sign-title {
  line-height: 112px;
}
#printer .show-sign {
  min-width: 150px;
  min-height: 31px;
  text-align: center;
  border-bottom: 1px solid #000;
}
#printer .approval-show-sign {
  text-align: left;
  min-width: 150px;
  height: 62px;
  border-bottom: 1px solid #000;
}
#printer .active-show-sign {
  display: flex;
  align-items: flex-end;
}
#printer .sign-img {
  margin-right: 10px;
}
#printer .watch-marker {
  font-size: 26px;
  line-height: 20px;
  text-align: center;
}
#printer .print-remark {
  padding: 10px 0px;
  text-align: left;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: #666666;
  border: 1px solid #000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
#printer .print-remark-title {
  display: inline-block;
  padding-left: 16px;
  text-align: center;
  margin-right: 250px;
}
#printer .print-remark-content {
  flex: 1;
}
</style>
